import { get } from 'jquery';
import {
    post,
    post2,
    fetch,
    fetch3,
    upload,
    upload2,
    patch,
    put,
    fetch2,
    postExport
  } from './request.js';
  let url = "http://47.103.205.52:8888/api/"
  // let url = "http://192.168.0.173/api/"
  export const Login = params => post(url + "v1/channel/login", params);
  export const Update = params => post(url + "v1/update", params);
  export const Add = params => post(url + "v1/add", params);
  export const Epress = params => post(url + "v1/express", params);
  export const Getlist = params => fetch(url + "v1/list", params);
  export const Del = params => post(url + "v1/destroy", params);
  export const BatchAdd = params => post(url + "v1/batchAdd", params);
  export const Analyse = params => post(url + "v1/temp/analyse", params);
  export const Addtemp = params => post(url + "v1/temp/add", params);
  export const Listtemp = params => fetch(url + "v1/temp/list", params);
  export const Expertsupdate = params => post(url +"v1/experts/update", params)
  export const Analyseone = params => post(url +"v1/experts/analyse", params);
  export const Deltep = params => post(url + "v1/temp/del", params);
  export const Updatetemp = params => post(url + "v1/temp/update", params);
  export const Skuupdate = params => post(url + "v1/temp/sku/update", params);
  export const Skudel = params => post(url + "v1/temp/sku/del", params);
  export const Catetemp = params => fetch(url + "v1/cate", params);
  export const Exportexe = params => post(url + "v1/temp/export", params);
  export const Getinfo = params => fetch(url + "v1/temp/info", params);
  export const ExpertsAll = params => fetch(url + "v1/experts", params);
  export const DelExperts = params => post(url +"v1/experts/delete", params);
  export const myExperts = params => fetch(url +"v1/temp/myExperts", params);
  export const Experts = params => post(url +"v1/experts", params);
  export const Export = params => postExport(url +"v1/temp/export", params);
  export const Capture = params => post2(url +"v1/goods_author/retrieve", params);
  export const CaptureList = params => fetch(url +"v1/goods_author/list", params);
  export const JX = params => fetch2("https://ec.snssdk.com/api/product/fxgajaxstaticitem?b_type_new=0&device_id=0&is_outside=1&preview=0&is_native_h5=1", params);



// WEBPACK FOOTER //
// ./src/api/api2.js